export const GET_CLIENT_MAPPED_DATA = "GET_CLIENT_MAPPED_DATA";
export const GET_INTEGRATION_TYPE = "GET_INTEGRATION_TYPE";
export const GET_CLIENT_LINKING_DATA = "GET_CLIENT_LINKING_DATA";
export const GET_TAX_NOT_LINKED_DATA = "GET_TAX_NOT_LINKED_DATA";
export const GET_FIRM_DOCUMENT_SYNC = "GET_FIRM_DOCUMENT_SYNC";